// src/services/EncryptService.js
import forge from 'node-forge';

export class EncryptService {
  constructor() {
    try {
      const publicKeyPem = process.env.VUE_APP_PUBLIC_KEY; 
      this.publicKey = forge.pki.publicKeyFromPem(publicKeyPem);
    } catch (error) {
      console.error('Clave pública inválida:', error);
      this.publicKey = null;
    }
  }

  encrypt(text) {
    if (!this.publicKey) {
      throw new Error('No se ha cargado una clave pública válida.');
    }

    try {
      const encryptedBytes = this.publicKey.encrypt(text, 'RSA-OAEP', {
        md: forge.md.sha256.create()
      });
      return forge.util.encode64(encryptedBytes); // Devuelve en base64
    } catch (error) {
      console.error('Error al cifrar:', error);
      return null;
    }
  }
}
